var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pt-1 d-none d-md-block",
      class: _vm.asset.theme.use_alternate_background_color
        ? "bg-background"
        : null,
      attrs: { id: "controllers" },
    },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            { attrs: { "align-h": "center" } },
            [
              _vm.asset.slideinstances.length
                ? _c(
                    "b-col",
                    { staticClass: "p-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "border-right",
                          class: _vm.viewSize === "video" ? "active" : null,
                          attrs: {
                            title:
                              _vm.viewSize === "video"
                                ? _vm.$t("controllers.reduce-video")
                                : _vm.$t("controllers.enlarge-video"),
                            size: "sm",
                            variant: "link-icon",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setView("video")
                            },
                          },
                        },
                        [
                          _c("b-img", {
                            staticClass: "video",
                            attrs: {
                              src: require("@/assets/img/icon-video.svg"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-col",
                {
                  staticClass: "p-0 d-none d-xl-block",
                  attrs: { cols: "auto" },
                },
                [
                  _c(
                    "b-btn",
                    {
                      staticClass: "border-right",
                      class: _vm.viewSize === "expand" ? "active" : null,
                      attrs: {
                        title:
                          _vm.viewSize === "expand"
                            ? _vm.$t("controllers.reduce-both")
                            : _vm.$t("controllers.enlarge-both"),
                        size: "sm",
                        variant: "link-icon",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setView("expand")
                        },
                      },
                    },
                    [
                      _c("b-img", {
                        staticClass: "fullscreen",
                        attrs: {
                          src: require("@/assets/img/icon-fullscreen.svg"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.asset.slideinstances.length
                ? _c(
                    "b-col",
                    { staticClass: "p-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-btn",
                        {
                          class: _vm.viewSize === "slide" ? "active" : null,
                          attrs: {
                            title:
                              _vm.viewSize === "slide"
                                ? _vm.$t("controllers.reduce-slide")
                                : _vm.$t("controllers.enlarge-slide"),
                            size: "sm",
                            variant: "link-icon",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setView("slide")
                            },
                          },
                        },
                        [
                          _c("b-img", {
                            staticClass: "ppt",
                            attrs: {
                              src: require("@/assets/img/icon-ppt.svg"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }